import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import CardAction from '../../../../../../../../components/card/CardAction';

export default function BackAction({
  className,
  onClick,
} = {
  className: '',
  onClick: () => null,
}) {
  return (
    <CardAction
      icon={<KeyboardBackspaceIcon aria-hidden='false' />}
      actionHandler={onClick}
      label='Go back'
      className={`btn-primary ${className}`}
      ariaLabel='Go back'
      title='Go back'
      data-test='go-back-action'
      disabled={false}
      tabIndex={0}
      aria-hidden='false'
    />
  );
}
